import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {UI_TEXTS} from "../../../enums/e-texts";

@Component({
  selector: 'app-go-game-task',
  templateUrl: './go-game-task.component.html',
  styles: []
})
export class GoGameTaskComponent extends GoBaseComponent{

  UI_TEXTS=UI_TEXTS;
  GO_COMPONENTS = GO_COMPONENTS;
  constructor() {
    super(GO_COMPONENTS.GAME_TASK);
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-game-task/go-game-task.component.ts